<template>
    <div class="nature-content-box">
        <div v-if="resultType == 'talent'" class="nature-content-title title2">天赋能力矩阵</div>
        <div v-else-if="resultType == 'report'" class="nature-talent-title-box" :class="{'border-none': resultType !== 'talent'}"><span class="nature-talent-title">天赋能力矩阵</span></div>
        <!-- 图形部分 -->
        <nature-talent-data-area
             v-if="natureTalentData.needpay == 0" :resultType="resultType">
        </nature-talent-data-area>
        <report-re-pay-bar v-if="resultType == 'report'" :lastTime="natureTalentData.lastTime" :productData="talentProductData['pay_31100']"></report-re-pay-bar>
        <!-- 先天天赋 -->
        <div v-if="natureTalentData.needpay == 0 && natureTalentData.des && natureTalentData.des.f" class="nature-content-talent">
            <div class="nature-talent-title-box"><span class="nature-talent-title">{{natureTalentData.des.f.title.indexOf('：') != -1 ? natureTalentData.des.f.title.slice(0, -1) : natureTalentData.des.f.title}}</span></div>
            <div class="nature-content-main" v-if="resultType == 'year'">
                <p class="nature-c-paragraph" v-for="baseText in natureTalentData.des.f.base" v-html="baseText"></p>
            </div>
            <div class="nature-content-main" v-else>
                <p class="nature-c-paragraph" v-for="baseText in natureTalentData.des.f.base" v-html="baseText"></p>
                <p class="nature-c-paragraph p-ral" v-for="contentData in natureTalentData.des.f.content">
                    <span class="nature-c-title green">{{contentData.title.slice(0, -1)}}：</span>
                    <span v-html="contentData.content"></span>
                </p>
            </div>
        </div>
        <!-- 后天表现 -->
        <div v-if="natureTalentData.needpay == 0 && natureTalentData.des && natureTalentData.des.s" class="nature-content-talent">
            <div class="nature-talent-title-box"><span class="nature-talent-title">{{natureTalentData.des.s.title.indexOf('：') != -1 ? natureTalentData.des.s.title.slice(0, -1) : natureTalentData.des.s.title}}</span></div>
            <div class="nature-content-main" v-if="natureTalentData.sContent">
                <p class="nature-c-paragraph" v-for="contentText in natureTalentData.sContent" v-html="contentText"></p>
            </div>
            <div class="nature-content-main" v-else-if="natureTalentData.des.s.content">
                <p class="nature-c-paragraph" v-for="contentText in natureTalentData.des.s.content" v-html="contentText"></p>
            </div>
        </div>
        <div v-if="natureTalentData.needpay == 0 && natureTalentData.des && natureTalentData.des.t" class="nature-content-supply">
            <p class="nature-c-paragraph" v-for="tText in natureTalentData.des.t" v-html="tText"></p>
        </div>
        <div v-if="natureTalentData.needpay == 1" class="nature-content-needpay2">
            <div class="nature-content-pp">
                <p>先天天赋及弱势提升解析</p>
                <p>适合发挥的工作领域分析</p>
                <p>天赋在今明两年的后天变化表现</p>
            </div>
            <nature-button 
                v-bind:buttonType="'2'"
                v-bind:productData="natureTalentData.product"
                v-bind:discount="natureTimeLimit != 0"
                v-bind:clickFunc="clickPay">
            </nature-button>
        </div>
        <div v-if="natureTalentData.needpay == 1 && natureCharacterData.needpay == 0" class="nature-content-box-joint"><span class="joint-l"></span><span class="joint-r"></span></div>
    </div>
</template>

<script>
import { CONFIG } from '../../modules/config';
import { MIX } from '../../modules/utils';
import ReportRePayBar from '../report/ReportRePayBar.vue';
import NatureButton from './NatureButton.vue'
import NatureTalentDataArea from './NatureTalentDataArea.vue'
export default {
    name: 'NatureTalent',
    components: { NatureButton, NatureTalentDataArea, ReportRePayBar },
    props: {
        resultType: {
            type: String,
            default() { return '' }
        },
    },
    computed: {
        talentProductData() {
            return this.$store.state.pay.talentProductData;
        },
        natureTalentData() {
            return this.resultType == 'year' ? this.$store.state.year.curYearReportTalentData : this.$store.state.report.natureTalentData;
        },
        natureCharacterData() {
            return this.$store.state.report.natureCharacterData;
        },
        natureTimeLimit() {
            return this.$store.state.report.natureTimeLimit;
        },
    },
    methods: {
        clickPay(params) {
            MIX.trackButtonClicked('talent_unlock_talent');
            var me = this,
                curSecond = this.$store.state.report.natureTimeLimit,
                detailInfo = this.$store.state.detail.personInfo;
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: params.data.pid,              //支付项目id
                    ptype: params.data.payType[2],     //支付方式
                    ext: detailInfo.id,                //支付的评测id
                    discount: curSecond > 0 ? CONFIG.character_discount : 1  //支付折扣
                },
                mixParams: {
                    pid: params.data.pid,
                    product_name: params.data.title,
                    price: params.data.price,
                    from: 'nature',
                },
                sucCb: function() {
                    console.log('支付成功，更新测评报告数据');
                    // 更新测验报告数据
                    if(detailInfo) {
                        me.$store.dispatch('report/getAiCharacter', {
                            detailInfo: detailInfo
                        });
                    }
                    // 更新ai状态
                    // me.$store.state.detail.personInfo.ai = 1;
                    // me.$store.dispatch('record/updateRecordListAIStatus', {
                    //     id: detailInfo.id
                    // });
                    // 支付成功
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: function() {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });
        },
        clickRePay() {

        }
    }
}
</script>